import { useState } from 'react';
import { FiTrash2 } from 'react-icons/fi';
import PersonCard from '../PersonCard/PersonCard';
import RemoveCoachModal from '../RemoveCoachModal/RemoveCoachModal';
import useRemoveCoach from '../../hooks/athlete/useRemoveCoach';
import styles from './MyCoaches.module.css';

const MyCoaches = ({ coaches }) => {
  const [coachToRemove, setCoachToRemove] = useState(null);
  const { remove } = useRemoveCoach();

  const handleOpenModal = (coach) => {
    setCoachToRemove(coach);
  };

  const handleCloseModal = () => {
    setCoachToRemove(null);
  };

  const handleConfirmRemove = async (coach) => {
    try {
      await remove(coach._id);
    } catch (error) {
      console.error('Error removing coach:', error);
    } finally {
      setCoachToRemove(null);
    }
  };

  return (
    <div className={styles.cardWrapper}>
      <h3 className={styles.title}>My Coaches</h3>
      <div className={styles.cardList}>
        {coaches?.length > 0 ? (
          coaches.map((coach) => (
            <div key={coach._id} className={styles.cardRow}>
              <PersonCard
                name={`${coach.firstName} ${coach.lastName}`}
                image={coach.profilePicture}
                role="coach"
              />
              <button
                className={styles.trashIconButton}
                onClick={() => handleOpenModal(coach)}
                aria-label={`Remove ${coach.firstName}`}
              >
                <FiTrash2 />
              </button>
            </div>
          ))
        ) : (
          <p className={styles.noCoaches}>No coaches connected yet.</p>
        )}
      </div>

      <RemoveCoachModal
        coachName={coachToRemove ? `${coachToRemove.firstName} ${coachToRemove.lastName}` : ''}
        isOpen={!!coachToRemove}
        onClose={handleCloseModal}
        onConfirm={() => handleConfirmRemove(coachToRemove)}
      />
    </div>
  );
};

export default MyCoaches;